export enum UpdateModalValues {
  NotNow = "Not now",
  Update = "Update"
}

export enum PushModalValues {
  NotNow = "Not now",
  TurnOn = "Turn on"
}

type CarrotModalStorage = {
  hasCrrModalTriggeredThisSession?: boolean
  appUpdateModalSelection?: UpdateModalValues
  appUpdateModalTimestamp?: number
  pushPermissionsModalSelection?: PushModalValues
  hasJourneyChangeModalTriggeredThisSession?: boolean
  hasCheckInModalTriggeredThisSession?: boolean
}

type CarrotPlanMessageStorage = {
  carrotPlanMessageDismissTimestamp?: number
}

export const CARROT_MODAL_STORAGE_KEY = "carrotModalStorage"
const CARROT_PLAN_MESSAGE_STORAGE_KEY = "carrotPlanMessageStorage"

const getCarrotModalStorage = (): CarrotModalStorage => {
  try {
    return JSON.parse(localStorage.getItem(CARROT_MODAL_STORAGE_KEY)) ?? {}
  } catch {
    return {}
  }
}

const getCarrotPlanMessageStorage = (): CarrotPlanMessageStorage => {
  try {
    return JSON.parse(localStorage.getItem(CARROT_PLAN_MESSAGE_STORAGE_KEY)) ?? {}
  } catch {
    return {}
  }
}

export const getHasCrrModalTriggeredThisSession = (): boolean => {
  const modalStorage = getCarrotModalStorage()
  return modalStorage?.hasCrrModalTriggeredThisSession ?? false
}

export const updateHasCrrModalTriggeredThisSession = (shouldCrrModalRender: boolean): void => {
  const modalStorage = getCarrotModalStorage()
  modalStorage.hasCrrModalTriggeredThisSession = shouldCrrModalRender
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(modalStorage))
}

export const resetHasCrrModalTriggeredThisSession = (): void => {
  const modalStorage = getCarrotModalStorage()
  delete modalStorage.hasCrrModalTriggeredThisSession
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(modalStorage))
}

export const getAppUpdateModalSelection = (): UpdateModalValues | undefined => {
  const modalStorage = getCarrotModalStorage()
  return modalStorage.appUpdateModalSelection
}

export const getAppUpdateModalTimestamp = (): number | undefined => {
  const modalStorage = getCarrotModalStorage()
  return modalStorage.appUpdateModalTimestamp
}

export const updateAppUpdateModalSelection = (modalButtonValue: UpdateModalValues): void => {
  const modalStorage = getCarrotModalStorage()
  modalStorage.appUpdateModalSelection = modalButtonValue
  modalStorage.appUpdateModalTimestamp = Date.now()
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(modalStorage))
}

export const getPushPermissionsModalSelection = (): PushModalValues | undefined => {
  const modalStorage = getCarrotModalStorage()
  return modalStorage.pushPermissionsModalSelection
}

export const updatePushPermissionsModalSelection = (modalButtonValue: PushModalValues): void => {
  const modalStorage = getCarrotModalStorage()
  modalStorage.pushPermissionsModalSelection = modalButtonValue
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(modalStorage))
}

export const getHasJourneyChangeModalTriggeredThisSession = (): boolean => {
  const modalStorage = getCarrotModalStorage()
  return modalStorage?.hasJourneyChangeModalTriggeredThisSession ?? false
}

export const updateHasJourneyChangeModalTriggeredThisSession = (shouldJourneyChangeModalRender: boolean): void => {
  const modalStorage = getCarrotModalStorage()
  modalStorage.hasJourneyChangeModalTriggeredThisSession = shouldJourneyChangeModalRender
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(modalStorage))
}

export const resetHasJourneyChangeModalTriggeredThisSession = (): void => {
  const modalStorage = getCarrotModalStorage()
  delete modalStorage.hasJourneyChangeModalTriggeredThisSession
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(modalStorage))
}

export const getCarrotPlanMessageDismissTimestamp = (): number | undefined => {
  const modalStorage = getCarrotPlanMessageStorage()
  return modalStorage.carrotPlanMessageDismissTimestamp
}

export const updateCarrotPlanMessageDismissTimestamp = (): void => {
  const modalStorage = getCarrotPlanMessageStorage()
  modalStorage.carrotPlanMessageDismissTimestamp = Date.now()
  localStorage.setItem(CARROT_PLAN_MESSAGE_STORAGE_KEY, JSON.stringify(modalStorage))
}

export const getHasCheckInModalTriggeredThisSession = (): boolean => {
  const modalStorage = getCarrotModalStorage()
  return modalStorage?.hasCheckInModalTriggeredThisSession ?? false
}

export const updateHasCheckInModalTriggeredThisSession = (shouldCheckInModalRender: boolean): void => {
  const modalStorage = getCarrotModalStorage()
  modalStorage.hasCheckInModalTriggeredThisSession = shouldCheckInModalRender
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(modalStorage))
}

export const resetHasCheckInModalTriggeredThisSession = (): void => {
  const modalStorage = getCarrotModalStorage()
  delete modalStorage.hasCheckInModalTriggeredThisSession
  localStorage.setItem(CARROT_MODAL_STORAGE_KEY, JSON.stringify(modalStorage))
}
